import React from 'react';
import classNames from 'classnames';
import PropTypes from 'prop-types';

import Placeholder from 'components/consumer/Placeholder';

const PDPInfoTable = ({
  items = [],
  loading = false,
  placeholderRowCount = 5,
  matchContentSize = false,
}) => {
  if (loading) {
    return (
      <div
        className={classNames('flex flex-col mx-0 my-4 w-full', {
          '!my-2': !matchContentSize,
        })}
      >
        {Array.from(
          { length: placeholderRowCount },
          (unused, index) => index
        ).map(key => (
          <div
            key={key}
            className={classNames(
              'items-start flex justify-between px-0 py-[.4rem] w-full',
              {
                '[border-bottom:1px_solid_#f1f1f1] last:[border-bottom:0]': matchContentSize,
              }
            )}
          >
            <Placeholder
              loading
              type="rect"
              style={{
                marginRight: 0,
                height: matchContentSize ? '23px' : '26px',
              }}
            />
          </div>
        ))}
      </div>
    );
  }

  return (
    <div className="flex flex-col mx-0 my-4 w-full">
      {items.map(({ label, value }) => {
        if (!`${value}`.includes('undefined')) {
          return (
            <div
              key={label}
              className="items-start [border-bottom:1px_solid_#f1f1f1] flex justify-between px-0 py-[.4rem] w-full last:[border-bottom:0]"
            >
              <div className="text-gray font-bold text-sm">{label}</div>
              <div className="text-gray text-sm max-w-[200px] text-right">
                {value}
              </div>
            </div>
          );
        }
        return null;
      })}
    </div>
  );
};

PDPInfoTable.propTypes = {
  items: PropTypes.arrayOf(
    PropTypes.shape({
      label: PropTypes.string.isRequired,
      value: PropTypes.string.isRequired,
    })
  ),
  loading: PropTypes.bool,
};

export default PDPInfoTable;
